import { render, staticRenderFns } from "./AdditionalCosts.vue?vue&type=template&id=10f2c600&scoped=true"
import script from "./AdditionalCosts.vue?vue&type=script&lang=js"
export * from "./AdditionalCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2c600",
  null
  
)

export default component.exports